'use client';

import React from 'react';
import AppLayout from '@/components/AppLayout';
import DispatchHeader from './components/DispatchHeader';
import DispatchBoard from './components/DispatchBoard';

export default function DispatchPage() {
  return (
    <AppLayout>
      <div className="flex flex-col h-full min-h-screen bg-background">
        <DispatchHeader />
        <div className="flex-1 flex flex-col gap-4 p-5 overflow-hidden">
          <DispatchBoard />
        </div>
      </div>
    </AppLayout>
  );
}
